import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: 'Llevaba años gastando en pastillas para mis rodillas. Con la guía de preparación de este manual, en 3 semanas el dolor ha bajado casi por completo. ¡Es un regalo de Dios!',
  name: 'Marta J.',
  age: '62 años',
  city: 'México'
}, {
  text: 'Lo que más me gustó es la guía de cultivo. Vivo en un piso pequeño y ya tengo mi propia albahaca medicinal y romero en la ventana.',
  name: 'Carmen R.',
  age: '55 años',
  city: 'España'
}, {
  text: 'El manual de tinturas del paquete de $26 es increíble. He fabricado mi propio extracto para el estrés y mi esposa duerme mucho mejor.',
  name: 'Ricardo M.',
  age: '48 años',
  city: 'Colombia'
}, {
  text: 'Tenía miedo de equivocarme con las dosis, pero este manual es muy claro. Ahora sé exactamente cuánto té de jengibre y cúrcuma debo tomar.',
  name: 'Lucía P.',
  age: '67 años',
  city: 'Argentina'
}, {
  text: 'El protocolo Detox me cambió la energía. Me siento desinflamada y ligera. Gracias por organizar este conocimiento de forma tan simple.',
  name: 'Elena G.',
  age: '58 años',
  city: 'Chile'
}];
export function Testimonials() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-paper-soft" data-id="element-168">
      <div className="max-w-3xl mx-auto" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-5 sm:mb-8" data-id="element-170">
          <h2 className="text-xl sm:text-3xl font-serif font-bold text-brand-forest mb-2 leading-tight" data-id="element-171">
            💬 Voces de nuestra comunidad de sanación
          </h2>
        </motion.div>

        <div className="space-y-3 sm:space-y-4" data-id="element-172">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-white border border-brand-border p-5 sm:p-6 rounded-xl shadow-sm" data-id="element-173">
              <div className="flex items-center gap-2 mb-3" data-id="element-174">
                <div className="flex text-brand-terracotta" data-id="element-175">
                  {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-176" />)}
                </div>
              </div>
              <p className="text-brand-text font-medium mb-3 sm:mb-4 text-sm sm:text-base leading-snug italic" data-id="element-177">
                "{t.text}"
              </p>
              <div className="border-t border-brand-border pt-3" data-id="element-178">
                <span className="text-xs sm:text-sm text-brand-forest font-bold" data-id="element-179">
                  {t.name}
                </span>
                <span className="text-xs sm:text-sm text-brand-muted font-medium" data-id="element-180">
                  {' '}
                  — {t.age}, {t.city}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}